import '@nettbureau/theme';
import 'radash';
import 'polished';
import { parseSpacing } from '../parsers/spacing.js';

/**
 * Generates CSS for applying spacing to an element.
 *
 * @param options - Options for the mixin.
 */ function spacing(options) {
    const { padding, margin } = options;
    return (theme)=>[
            padding && generateSpacingStyle(theme, padding, 'padding'),
            margin && generateSpacingStyle(theme, margin, 'margin')
        ];
}
/**
 * Generates an individual spacing style object.
 *
 * @param theme - The theme object.
 * @param spacing - The spacing value to evaluate.
 * @param type - The type of spacing.
 */ function generateSpacingStyle(theme, spacing, type) {
    return isBoxSpacing(spacing) ? boxSpacing(theme, spacing, type) : {
        [type]: parseSpacing(theme, spacing)
    };
}
/**
 * Determines if the given spacing value is a box spacing object.
 *
 * @param spacing - The spacing value to check.
 */ function isBoxSpacing(spacing) {
    return typeof spacing === 'object' && !Array.isArray(spacing);
}
/**
 * Generates CSS for applying box spacing to an element.
 *
 * @param theme - The theme object.
 * @param box - The box spacing object.
 * @param type - The type of box spacing, either 'padding' or 'margin'.
 */ function boxSpacing(theme, box, type) {
    const { x, y, top, right, bottom, left } = box;
    return [
        ...[
            x && boxSpacing(theme, {
                left: x,
                right: x
            }, type)
        ],
        ...[
            y && boxSpacing(theme, {
                top: y,
                bottom: y
            }, type)
        ],
        top && {
            [`${type}Top`]: parseSpacing(theme, top)
        },
        right && {
            [`${type}Right`]: parseSpacing(theme, right)
        },
        bottom && {
            [`${type}Bottom`]: parseSpacing(theme, bottom)
        },
        left && {
            [`${type}Left`]: parseSpacing(theme, left)
        }
    ];
}

export { spacing };
//# sourceMappingURL=spacing.js.map
